// pages/Page1.tsx
import { Link } from 'react-router-dom';

const Page8 = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <div className="pagetitle">Page 8</div>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
      </p>
      <p>
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </p>
      <Link to="/" className="foottitle">&#60; Back to Home</Link>
    </div>
  );
};

export default Page8;   